import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import classNames from "classnames";
import "./CustomTable.scss";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: '#212328 !important',
    },
    "&:nth-of-type(even)": {
      backgroundColor: '#383838 !important'
    }
  },
}))(TableRow);

interface TableProps {
  headers: { key: string; label: string }[];
  data: any[];
  currentUser: string;
  noDataTitle?: string;
}

export default function CustomizedTables(props: TableProps) {
  const { headers, data, currentUser, noDataTitle } = props;
  return (
    <TableContainer className="tableContainer" component={Paper}>
      <Table className="tableBox" aria-label="customized table">
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <StyledTableCell
                key={header.key}
                className={classNames({
                  cellAddress: header.key === "address",
                })}
              >
                {header.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <StyledTableRow
              key={index}
              className={classNames({
                rowActive: row?.address === currentUser,
              })}
            >
              {headers.map((header) => (
                <StyledTableCell
                  key={`${index}-${header.key}`}
                  component="td"
                  scope="row"
                >
                  {header.key === "address" && row?.address === currentUser && (
                    <span className="me">Me</span>
                  )}
                  {row[header.key]}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
          {!data.length && (
            <StyledTableRow>
              <StyledTableCell colSpan={3} className="tableNoData">
                {noDataTitle || "No Data"}
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
